

















































































































































































import { Locale } from 'vue-i18n';
import { Component, Prop, Vue, Emit } from 'vue-property-decorator';
import ListLinkItem from '@/components/molecules/ListLinkItem.vue';
import PortalUserInfoPanel from '@/components/organisms/PortalUserInfoPanel.vue';
import { commonModule } from '@/store/modules/CommonStore';
import { globalSnackbarModule } from '@/store/modules/GlobalSnackbarStore';
import { RouterItem, LoginInfo } from '@/types/type';
import { getDisabledRoutes } from '@/utils/CommonUtils';
import { callCheckStepFunctionStatus } from '@/utils/UserManagementUtils';
import { PAGE_PATH_BY_NAME, REL, SNACKBAR_TIMEOUT } from '@/utils/consts';

const versionNo = require('@/../package.json').version;

interface IUserInfo {
  userName: string;
  affiliationName: string;
  language: Locale;
}

export interface AppBarLiteralTexts {
  placeHolder: string;
  searchMessage: string;
  setting: string;
  logout: string;
  version: string;
  about: string;
  copyright: string;
  ossLicense: string;
}

@Component({
  components: { ListLinkItem, PortalUserInfoPanel },
})
export default class AppBar extends Vue {
  private drawer = null;
  private versionNo: string = versionNo;

  @Prop()
  private appMenus!: RouterItem[];
  @Prop()
  private userInfo!: IUserInfo;
  @Prop()
  private literalTexts!: AppBarLiteralTexts;
  @Prop()
  private isPortalEnabled!: boolean;

  private filteredAppMenus: RouterItem[] = [];

  private loginInfo!: LoginInfo;

  private disabledRoutes: string[] = [];

  private aboutDialog: boolean = false;

  private get filteredAppMenusList(): RouterItem[] {
    if (this.appMenus) {
      this.filteredAppMenus = this.appMenus.filter(
        appMenu => !this.disabledRoutes.includes(appMenu.path)
      );
    }
    return this.filteredAppMenus;
  }

  public async created(): Promise<void> {
    const loginInfo: LoginInfo = commonModule.loginInfo;
    this.loginInfo = loginInfo;
    const disabledRoutes = await getDisabledRoutes(
      loginInfo.tenant,
      loginInfo.landscape,
      loginInfo.loginName
    );
    this.disabledRoutes = disabledRoutes;

    if (globalSnackbarModule.snackbarVisible) {
      const { executionArn } = globalSnackbarModule;
      if (executionArn) {
        await callCheckStepFunctionStatus(executionArn);
      }
      setTimeout(() => {
        globalSnackbarModule.hideSnackbarAction();
        globalSnackbarModule.resetExecutionArnAction();
      }, SNACKBAR_TIMEOUT);
    }
  }

  private get sideMenuIndex(): number {
    const sideMenus: RouterItem[] = this.filteredAppMenusList;
    return sideMenus.findIndex(
      (item: RouterItem) => location.pathname === item.path
    );
  }

  private clickOssLicense() {
    window.open(PAGE_PATH_BY_NAME.OSSLicense, '_blank', REL);
  }

  @Emit('go-to-search-page')
  private goToSearchPage() {}

  private displayAbout() {
    this.aboutDialog = true;
  }

  @Emit('open-setting')
  private openSetting() {}

  @Emit('logout')
  private logout() {}

  @Emit('goToUserManualTopPage')
  private goToUserManualTopPage() {}

  private get progressCircularVisible() {
    return globalSnackbarModule.progressCircularVisible;
  }

  private get snackbarVisible() {
    return globalSnackbarModule.snackbarVisible;
  }

  private get snackbarMessage() {
    return globalSnackbarModule.snackbarMessage;
  }
}
